package com.ijoin.update

import kotlinx.browser.window

actual fun openStoreUrl(url: String) {
    window.open(url, "_blank")
}
